<template>
  <button
    v-on="$listeners"
    class="button d-flex justify-content-center align-items-center"
    :class="[
      colorText,
      {
        'button-primary': primary,
        'button-secondary': secondary,
        'button-with-icon': prependIcon,
        'button--loading': loading,
      },
    ]"
  >
    <span class="" v-if="!loading">
      <img
        v-if="prependIcon"
        :src="require(`../../assets/icons/${this.prependIcon}.png`)"
      />
      <span><slot /></span>
    </span>
    <span class="button__loader" v-if="loading">
      <div
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        class="progress-circular progress-circular--indeterminate"
        style="height: 23px; width: 23px;"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
          style="transform: rotate(0deg);"
        >
          <circle
            fill="transparent"
            cx="43.80952380952381"
            cy="43.80952380952381"
            r="20"
            stroke-width="3.8095238095238093"
            stroke-dasharray="125.664"
            stroke-dashoffset="125.66370614359172px"
            class="progress-circular__overlay"
          ></circle>
        </svg>
        <div class="progress-circular__info"></div>
      </div>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    primary: Boolean,
    secondary: Boolean,
    prependIcon: String,
    loading: Boolean,
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    colorText() {
      return this.color ? `${this.color}--text` : null;
    },
  },
};
</script>
